import React from "react";
import { Link } from "@tanstack/react-router";
import { Modal } from "./ui/modal/modal";
import { Button } from "./ui/button";
import { Clock } from "lucide-react";
import { PlanBadge } from "./plan-badge";
import { MembershipPlan } from "~/lib/schemas";

export type LifetimeDealModalVariant = "public" | "coach";

export const LifetimeDealModal = ({
  isOpen,
  onClose,
  variant = "public",
}: {
  isOpen: boolean;
  onClose: () => void;
  variant?: LifetimeDealModalVariant;
}) => {
  return (
    <Modal.Root open={isOpen}>
      <Modal.Panel>
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="bg-primary/10 rounded-full p-3">
            <Clock className="text-text-primary h-6 w-6" />
          </div>
          <h2 className="text-text-primary font-heading text-2xl font-semibold">
            2024 Lifetime Deal
          </h2>
          <p className="text-text-secondary">
            Get lifetime access to all features with a one-time payment. Special
            offer available until{" "}
            <span className="font-medium">December 31, 2024</span>.
          </p>
          <div className="flex flex-col items-center gap-3">
            <div className="flex items-center gap-3">
              <PlanBadge membershipPlan={MembershipPlan.Pro} />
              <span className="font-medium">$1,499 one-time</span>
            </div>
            <div className="flex items-center gap-3">
              <PlanBadge membershipPlan={MembershipPlan.ProPlus} />
              <span className="font-medium">$2,999 one-time</span>
            </div>
          </div>
          {"public" === variant ? (
            <>
              <p className="text-text-tertiary text-sm">
                Create an account or log in to your existing account to upgrade
                to a lifetime plan
              </p>
              <Button onClick={() => onClose()}>Got it</Button>
            </>
          ) : (
            <div className="flex gap-3">
              <Button variant="outline" onClick={() => onClose()}>
                Maybe later
              </Button>
              <Link to="/coach/membership-plans">
                <Button onClick={() => onClose()}>Upgrade now</Button>
              </Link>
            </div>
          )}
        </div>
      </Modal.Panel>
    </Modal.Root>
  );
};
